import { Loader2, Check, CheckCircle, X } from "lucide-react";
import { motion } from "framer-motion";
import {
	Tooltip,
	TooltipTrigger,
	TooltipContent,
} from "@/components/ui/tooltip";

interface ValidationCTAProps {
	readonly isValidated: boolean;
	readonly allDatesUnchecked: boolean;
	readonly isValidating: boolean;
	readonly onValidate: () => void;
}

export function ValidationCTA({
	isValidated,
	allDatesUnchecked,
	isValidating,
	onValidate,
}: ValidationCTAProps) {
	if (isValidated) {
		return (
			<motion.div
				key="cta-validated"
				initial={{ opacity: 0, y: 4 }}
				animate={{ opacity: 1, y: 0 }}
				exit={{ opacity: 0, y: -4 }}
				transition={{ duration: 0.2 }}
			>
				<Tooltip>
					<TooltipTrigger asChild>
						<button
							onClick={onValidate}
							disabled={isValidating}
							className="w-full flex items-center justify-center gap-2 px-5 py-3 rounded-xl text-sm font-semibold transition-all disabled:opacity-50 text-white"
							style={{ background: "hsl(var(--v10-status-error))" }}
						>
							{isValidating ? (
								<Loader2 className="h-4 w-4 animate-spin" />
							) : (
								<X className="h-4 w-4" />
							)}
							Invalider vidéo
						</button>
					</TooltipTrigger>
					<TooltipContent side="top" className="text-xs">
						Annuler la validation et repasser en revue
					</TooltipContent>
				</Tooltip>
			</motion.div>
		);
	}

	if (allDatesUnchecked) {
		return (
			<motion.div
				key="cta-draft"
				initial={{ opacity: 0, y: 4 }}
				animate={{ opacity: 1, y: 0 }}
				exit={{ opacity: 0, y: -4 }}
				transition={{ duration: 0.2 }}
			>
				<Tooltip>
					<TooltipTrigger asChild>
						<button
							onClick={onValidate}
							disabled={isValidating}
							className="w-full flex items-center justify-center gap-2 px-5 py-3 rounded-xl text-sm font-semibold transition-all disabled:opacity-50"
							style={{
								background: "hsl(var(--v10-bg-hover))",
								color: "hsl(var(--v10-text-primary))",
							}}
						>
							{isValidating ? (
								<Loader2 className="h-4 w-4 animate-spin" />
							) : (
								<CheckCircle className="h-4 w-4" />
							)}
							Enregistrer comme brouillon
						</button>
					</TooltipTrigger>
					<TooltipContent side="top" className="text-xs">
						La vidéo sera enregistrée sans programmation
					</TooltipContent>
				</Tooltip>
			</motion.div>
		);
	}

	return (
		<motion.div
			key="cta-validate"
			initial={{ opacity: 0, y: 4 }}
			animate={{ opacity: 1, y: 0 }}
			exit={{ opacity: 0, y: -4 }}
			transition={{ duration: 0.2 }}
		>
			<Tooltip>
				<TooltipTrigger asChild>
					<button
						onClick={onValidate}
						disabled={isValidating}
						className="w-full flex items-center justify-center gap-2 px-5 py-3 rounded-xl text-sm font-semibold transition-all disabled:opacity-50 text-white"
						style={{ background: "hsl(var(--v10-status-success))" }}
					>
						{isValidating ? (
							<Loader2 className="h-4 w-4 animate-spin" />
						) : (
							<Check className="h-4 w-4" />
						)}
						Valider ce contenu
					</button>
				</TooltipTrigger>
				<TooltipContent side="top" className="text-xs">
					La vidéo sera alors programmée pour publication
				</TooltipContent>
			</Tooltip>
		</motion.div>
	);
}
